export default "__VITE_ASSET__CBpx4ref__"